import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: 0,
}

export const cPA = createSlice({
    name: 'cPA',
    initialState,
    reducers: {
        addCPA: (state, action) => {
            state.value = (action.payload);
        }
    },
})


export const { addCPA } = cPA.actions

export default cPA.reducer